module.exports = __webpack_public_path__ + "media/images/emblems/Schnottwil-blason-29105a466d1b1427379f19d3e3c4f887.png";